import { EditorState, RichUtils } from "draft-js";

/**
 * @param  {EditorState} editorState
 * @param  {String}      entityType
 * @param  {Object}      data
 * @param  {String}      mutability
 * @return {EditorState}
 */
export default function insertEntity(
  editorState,
  entityType,
  data,
  mutability = "MUTABLE",
) {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity(
    entityType,
    mutability,
    data,
  );

  const nextState = EditorState.set(editorState, {
    currentContent: contentStateWithEntity,
  });

  return RichUtils.toggleLink(
    nextState,
    nextState.getSelection(),
    contentStateWithEntity.getLastCreatedEntityKey(),
  );
}
